module.exports = __webpack_public_path__ + "fonts/display-heavy.e403686e.woff";